import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    guardian: { //object, optional // Người giám hộ
        register_code: null, //string, optional // mã đăng ký ms
        mobile: null, //string, optional // Số điện thoại
        cmnd_number: null, //string, optional // cmnd người giám hộ
        bhyt_number: null, //string, optional // Bảo hiểm y tế
        gioi_tinh: null, //integer, optional // Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
        first_name: null, //string, optional // Tên
        last_name: null, //string, optional // Họ + tên đệm
        nationality_name: null, //string, optional // Tên quốc tịch
        passport_no: null, //string, optional // Số hộ chiếu
        nationality_code: null, //string, optional // Mã quốc gia
        dob: null, //long, optional // Ngày sinh
        card_code: null, //string, optional // Số thẻ
    },
    register_code: null, //string, optional // mã đăng ký ms
    mobile: null, //string, optional // Số điện thoại
    cmnd_number: null, //string, optional // cmnd người giám hộ
    bhyt_number: null, //string, optional // Bảo hiểm y tế
    gioi_tinh: null, //integer, optional // Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
    first_name: null, //string, optional // Tên
    last_name: null, //string, optional // Họ + tên đệm
    nationality_name: null, //string, optional // Tên quốc tịch
    passport_no: null, //string, optional // Số hộ chiếu
    nationality_code: null, //string, optional // Mã quốc gia
    dob: null, //long, optional // Ngày sinh
    card_code: null, //string, optional // Số thẻ
    created_time: null, //datetime, optional // Thời gian tạo
    user_id: null, //IdRef, optional // Người tạo
};

// validation form
model.validForm = {

    guardian: { //object, optional // Người giám hộ
        register_code: [], //string, optional // mã đăng ký ms
        mobile: [], //string, optional // Số điện thoại
        cmnd_number: [], //string, optional // cmnd người giám hộ
        bhyt_number: [], //string, optional // Bảo hiểm y tế
        gioi_tinh: [], //integer, optional // Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
        first_name: [], //string, optional // Tên
        last_name: [], //string, optional // Họ + tên đệm
        nationality_name: [], //string, optional // Tên quốc tịch
        passport_no: [], //string, optional // Số hộ chiếu
        nationality_code: [], //string, optional // Mã quốc gia
        dob: [], //long, optional // Ngày sinh
        card_code: [], //string, optional // Số thẻ
    },
    register_code: [], //string, optional // mã đăng ký ms
    mobile: [], //string, optional // Số điện thoại
    cmnd_number: [], //string, optional // cmnd người giám hộ
    bhyt_number: [], //string, optional // Bảo hiểm y tế
    gioi_tinh: [], //integer, optional // Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
    first_name: [], //string, optional // Tên
    last_name: [], //string, optional // Họ + tên đệm
    nationality_name: [], //string, optional // Tên quốc tịch
    passport_no: [], //string, optional // Số hộ chiếu
    nationality_code: [], //string, optional // Mã quốc gia
    dob: [], //long, optional // Ngày sinh
    card_code: [], //string, optional // Số thẻ
    created_time: [], //datetime, optional // Thời gian tạo
    user_id: [], //IdRef, optional // Người tạo  
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
};

// validation các form khác
model.validFormOther = {
};

model.excelKhachDuLich = {
    formModel: {
        Guardian: { //object, optional // Người giám hộ
            RegisterCode: null, //string, optional // mã đăng ký ms
            Mobile: null, //string, optional // Số điện thoại
            CmndNumber: null, //string, optional // cmnd người giám hộ
            BhytNumber: null, //string, optional // Bảo hiểm y tế
            GenderId: null, //integer, optional // Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
            FirstName: null, //string, optional // Tên
            LastName: null, //string, optional // Họ + tên đệm
            NationalityName: null, //string, optional // Tên quốc tịch
            PassportNo: null, //string, optional // Số hộ chiếu
            NationalityCode: null, //string, optional // Mã quốc gia
            Dob: null, //long, optional // Ngày sinh
            CardCode: null, //string, optional // Số thẻ
        },
        RegisterCode: null, //string, optional // mã đăng ký ms
        Mobile: null, //string, optional // Số điện thoại
        CmndNumber: null, //string, optional // cmnd người giám hộ
        BhytNumber: null, //string, optional // Bảo hiểm y tế
        GenderId: null, //integer, optional // Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
        FirstName: null, //string, optional // Tên
        LastName: null, //string, optional // Họ + tên đệm
        NationalityName: null, //string, optional // Tên quốc tịch
        PassportNo: null, //string, optional // Số hộ chiếu
        NationalityCode: null, //string, optional // Mã quốc gia
        Dob: null, //long, optional // Ngày sinh
        CardCode: null, //string, optional // Số thẻ        
    },


    //Thay đổi thứ tự config với file excel bằng trường index, trường code phải sửa cả template, name không dùng tới
    configIndex:
        [
            {
                index: 0,
                code: "excel_stt",
                name: "STT"
            },
            {
                index: 1,
                code: "excel_ho_dem",
                name: "Họ đệm"
            },
            {
                index: 2,
                code: "excel_ten",
                name: "Tên"
            },
            {
                index: 3,
                code: "excel_ngay_sinh",
                name: "Ngày sinh"
            },
            {
                index: 4,
                code: "excel_thang_sinh",
                name: "Tháng sinh"
            },
            {
                index: 5,
                code: "excel_nam_sinh",
                name: "Năm sinh"
            },
            {
                index: 6,
                code: "excel_gioi_tinh",
                name: "Giới tính"
            },
            {
                index: 7,
                code: "excel_loai_giay_to",
                name: "Loại giấy tờ"
            },
            {
                index: 8,
                code: "excel_so_giay_to",
                name: "Số giấy tờ"
            },
            {
                index: 9,
                code: "excel_dien_thoai",
                name: "Số điện thoại"
            },
            {
                index: 10,
                code: "excel_so_the_bhyt",
                name: "Số thẻ BHYT"
            },
            {
                index: 11,
                code: "excel_quoc_tich",
                name: "Quốc tịch"
            },
            {
                index: 12,
                code: "excel_ma_quoc_gia",
                name: "Mã quốc gia"
            },

            {
                index: 13,
                code: "excel_ho_dem_ngh",
                name: "Họ đệm (người giám hộ)"
            },
            {
                index: 14,
                code: "excel_ten_ngh",
                name: "Tên (người giám hộ)"
            },
            {
                index: 15,
                code: "excel_ngay_sinh_ngh",
                name: "Ngày sinh (người giám hộ)"
            },
            {
                index: 16,
                code: "excel_thang_sinh_ngh",
                name: "Tháng sinh (người giám hộ)"
            },
            {
                index: 17,
                code: "excel_nam_sinh_ngh",
                name: "Năm sinh (người giám hộ)"
            },
            {
                index: 18,
                code: "excel_gioi_tinh_ngh",
                name: "Giới tính (người giám hộ)"
            },
            {
                index: 19,
                code: "excel_loai_giay_to_ngh",
                name: "Loại giấy tờ (người giám hộ)"
            },
            {
                index: 20,
                code: "excel_so_giay_to_ngh",
                name: "Số giấy tờ (người giám hộ)"
            },
            {
                index: 21,
                code: "excel_so_dien_thoai_ngh",
                name: "Số điện thoại (người giám hộ)"
            },
            {
                index: 22,
                code: "excel_so_the_bhyt_ngh",
                name: "Số thẻ BHYT (người giám hộ)"
            },
            {
                index: 23,
                code: "excel_quoc_tich_ngh",
                name: "Quốc tịch (người giám hộ)"
            },
            {
                index: 24,
                code: "excel_ma_quoc_gia_ngh",
                name: "Mã quốc gia (người giám hộ)"
            },

        ]
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["created_time", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            first_name: "",
            last_name: "",
            cmnd_number: "",
            reason: ''
        },
        valid: {
            first_name: [],
            last_name: [],
            cmnd_number: [],
            reason: []
        },
        operator: {
            first_name: ":regex_i:",
            last_name: ":regex_i:", //:regex:, $vn_text=Viêt nam
            cmnd_number: ":regex:",
            reason: ":is_null:"
        }
    }
};

export default model;